// extracted by mini-css-extract-plugin
export default {"caption":"DeepResearchSection_caption__02rQc","title":"DeepResearchSection_title__yh702","options":"DeepResearchSection_options__smrbF","root":"DeepResearchSection_root__tDJcL"};